import React from 'react';

import type { CertificateBannerContentProps } from './__content/certificate-banner__content';

export type Props<B extends boolean | JSX.Element = true> = {
    imageSrc: string | null;
    imageStyle?: React.CSSProperties;
    mix?: string;
    theme?: 'default' | 'yellow' | 'purple' | 'blue' | 'aqua';
} & (CertificateBannerContentProps<B> | ({ showButton?: undefined } & CertificateBannerContentProps<true>));

export enum CERTIFICATE_LAYOUT {
    WIDE = 'wide',
    NARROW = 'narrow',
}
